<template>
  <div>
    <table cellpadding="0" cellspacing="0" border="1" width="100%" style="border-color: #8f8f8f;">
      <tr style="background-color: #ccc;" class="text-center">
        <th rowspan="2">Total de folios hasta aquí</th>
        <th>Fisicos</th>
        <th>Electrónico</th>
        <th>Total</th>
      </tr>
      <tr class="text-center" :class="(visorpdf==true)?'text-warning':''">
        <td>{{ foliosFisico }}</td>
        <td>{{ totalFolios-foliosFisico }}</td>
        <td>{{ totalFolios }}</td>
      </tr>
    </table>
    <table cellpadding="0" cellspacing="0" border="1" width="100%" style="border-color: #8f8f8f;">
      <tr style="background-color: #ccc;">
        <th>Registros</th>
        <th style="text-align: center;">Archivos</th>
      </tr>
      <tr v-for="(item, index) in archivosreferentes.archivosdoc" :key="index" style="border-top: 1px #ccc solid;" :class="(visorpdf==true)?'text-warning':''">
        <td> Reg.doc: {{ item.iddocumento }} <p><b>Folios:</b> {{ item.docu_folios }}</p>
        </td>
        <td v-if="item.docu_archivo.length>0">
          <!-- <small>{{item.tipo_documento.tdoc_descripcion}} N° {{('000000' + item.docu_numero_doc).slice(-6)}}-{{ item.docu_fecha_doc.substr(0, 4) }}-{{ item.docu_siglas_doc }} </small> -->
          <small>{{ item.tipo_documento.tdoc_descripcion }} N° {{ ('000000' + item.docu_numero_doc).slice(-6) }}-{{ item.docu_siglas_doc }} </small>
          <table cellpadding="0" cellspacing="0" border="1" width="100%" bordercolor="#ccc">
            <tr v-for="(item2, index2) in item.docu_archivo" :key="index2" style="border-top: 1px #ccc solid;">
              <td v-if="item2.file_mostrar===true">
                <!-- <a href="">({{ index2 }})-{{ item2.file_name }}</a> -->

                <button
                  type="button"
                  class="btn btn-xs btn-link doc-link"
                  @click.stop="imprimirDocumentoPdf({id:item2.id, id_documento:item2.id_documento, file_tipo: item2.file_tipo, file_name: item2.file_name, tipo:1})"
                >
                  <span style="color:blue;font-size:70%" :class="(visorpdf==true)?'text-warning':''">{{ getFormatBytes(item2.file_size) }}</span>
                  <span
                    v-if="item2.file_principal != null"
                    :class="item2.file_principal? 'badge badge-danger': 'badge badge-warning'"
                  >
                    {{ item2.file_principal?'P':'A' }}
                  </span>
                  <span
                    :class="
                      item2.file_tipo.indexOf('image') === 0
                        ? 'glyphicon glyphicon-picture'
                        : 'glyphicon glyphicon-file'
                    "
                  ></span>
                  {{ item2.file_name }}
                </button><span style="color:red;font-size:70%">{{ 'Fecha Adjuntada: '+item2.created_at.substr(0, 10) }}</span>



              </td>
              <td v-else>
                <span class="badge badge-info">El trámite fue realizado de forma física</span>
              </td>
            </tr>
          </table>
        </td>
        <td v-else>
          <!-- <small>{{item.tipo_documento.tdoc_descripcion}} N° {{('000000' + item.docu_numero_doc).slice(-6)}}-{{ item.docu_fecha_doc.substr(0, 4) }}-{{ item.docu_siglas_doc }} </small> <br/> -->
          <small>{{ item.tipo_documento.tdoc_descripcion }} N° {{ ('000000' + item.docu_numero_doc).slice(-6) }}-{{ item.docu_siglas_doc }} </small> <br />
          <span class="badge badge-info">El trámite fue realizado de forma física</span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import axios from '@/js/plugins/client'
import Vuex from 'vuex'
export default {
  name  : 'Resumenfolios',
  props : {
    iddocumento : {
      type    : Number,
      default : 0
    }
  },

  data() {
    return {
      archivosreferentes : {
        archivosdoc : null
      },
      visorpdf : false
      
    };
  },
  computed : {
    ...Vuex.mapGetters([
      'getFormatBytes'
    ]),
    foliosFisico(){
      return this.archivosreferentes.archivosdoc!=null?this.archivosreferentes.archivosdoc.filter(d=>d.docu_archivo.filter(f=>f.file_mostrar==1).length==0).reduce((a,c)=>a+c.docu_folios,0):0
    },
    totalFolios(){
      return this.archivosreferentes.archivosdoc!=null?this.archivosreferentes.archivosdoc.reduce((a,c)=>a+c.docu_folios,0):0
    }
  },

  mounted() {
    // if(this.doiddocumento!=0)
    // {this.mostrarresultados(this.iddocumento)}
    
    
  },

  methods : {
    ...Vuex.mapActions(['buscarByDocumento', 'addRuta', 'imprimirDocumentoPdf']),
    mostrarresultados(iddoc,visor=false)//Actual tramite
    {
      this.visorpdf=visor
      var url='/archivoscargados/'+iddoc;

      axios.get(url).then(res=>{
        // console.log(res.data)
        this.archivosreferentes=res.data
        // eslint-disable-next-line no-undef
        $('#verarchivostotal').modal();
      })
    },
  },
};
</script>

<style scoped>
  .table tbody tr td,
  .table thead tr th {
    font-size: 10px;
    font-family: Tahoma;
    vertical-align: middle;
  }
</style>